"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileTypeFromFileName = exports.getContentTypeFromDataURL = void 0;
const getContentTypeFromDataURL = (dataURL) => dataURL.substring(dataURL.indexOf(':') + 1, dataURL.indexOf(';'));
exports.getContentTypeFromDataURL = getContentTypeFromDataURL;
const getFileTypeFromFileName = (fileName) => {
    const maxIndexOfPeriod = fileName.lastIndexOf('.');
    return fileName.substring(maxIndexOfPeriod + 1, fileName.length);
};
exports.getFileTypeFromFileName = getFileTypeFromFileName;
//# sourceMappingURL=utils.js.map